<template>
  <div class="create-system">
    <div class="breadcrumb" style="background: #fff">编辑SKU组</div>
    <div class="third-title">SKU组基础信息</div>
    <div class="order-detail-basic">
      <el-form :model="skuList" label-width="130px">
        <el-form-item label="SKU组名称:">
          <el-input v-model="skuVo.skuGroupName"></el-input>
        </el-form-item>
        <el-form-item label="SKU组图片:">
          <div class="upload-img">
            <input type="file" name="" id="input_img" @change="upload($event)" />
            <el-button round>上传图片</el-button>
          </div>
          <div id="show_img" style="width: 100%;" v-if="skuVo.skuGroupImage">
            <img :src="skuVo.skuGroupImage" alt="" style="max-width: 200px;float: left">
          </div>
        </el-form-item>
        <div class="third-title" style="margin-left: 0;margin-bottom: 20px;">SKU组详细信息</div>
        <el-form-item id="aaadd" v-if="$route.query.onSale === 'false'" label="选择产品:">
          <el-cascader :show-all-levels="false" clearable v-model="categoryId" @change="getSpuList" :props="props"></el-cascader>
          <el-select v-model="selectSpuId" clearable v-show="categoryId !== null" @change="getSpuMsg" placeholder="请选择">
            <el-option v-for="item in spuList" :key="item.id" :value="item.id" :label="item.spuName" style="height: auto"></el-option>
          </el-select>
          <!-- <el-button type="primary" v-show="selectSpuId!==''" @click="getSpuMsg" style="margin-left:20px" round>确定</el-button> -->
        </el-form-item>
        <el-form-item label="选择SKU组:" v-if="$route.query.onSale === 'false'">
          <el-select v-model="skuList.skuGroup" value-key="id" @change="getSkuListBySkuGroupId" placeholder="请选择">
            <el-option v-for="item in skuGroupListBySpuId" :key="item.id" :label="item.skuGroupName" :value="item" style="height: auto"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="$route.query.onSale === 'false'">
          <el-table :data="tableData" border :row-class-name="RowClassName">
            <el-table-column label="SKU名称" min-width="100px" prop="skuName"></el-table-column>
            <el-table-column label="SKU组名称" min-width="100px" prop="skuGName">
              <template>{{ skuList.skuGroup.skuGroupName }}</template>
            </el-table-column>
            <el-table-column label="SKU组图片" min-width="100px">
              <template>
                <img style="max-width:100px" :src="skuList.skuGroup.skuGroupImage" alt="">
              </template>
            </el-table-column>
            <el-table-column label="属性组合" min-width="100px" prop="attr">
              <template>{{ skuList.skuGroup.dictSet }}</template>
            </el-table-column>
            <el-table-column label="尺寸" min-width="100px" prop="attr">
              <template slot-scope="scope">
                <span @click="checkSizeGroup(scope.row)" class="color-blue">查看尺寸组</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="100px">
              <template v-slot="scope"><span class="color-blue" @click="addSKUGroup(scope.row)">添加</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="套系内SKU组合:">
          <el-tag v-for="(tag, index) in tags" :key="tag.skuName" :closable="$route.query.onSale === 'false'" :disable-transitions="false" @close="handleClose(tag, index)" type="info"> {{ tag.skuName
          }}</el-tag>
        </el-form-item>
        <div style="display: flex;">
          <el-form-item :label="$route.query.spuProperty === 'NORMAL' ? '平台价格' : '基础P平台价格:'">
            <el-input v-model="skuVo.skuList[0].basePagePrice" type="number" :min="0" :disabled="$route.query.onSale == 'true' ? true : false"></el-input>
          </el-form-item>
          <el-form-item :label="$route.query.spuProperty === 'NORMAL' ? '积分价格' : '基础P积分价格:'" v-if="$route.query.showPoint == 'true'">
            <el-input v-model="skuVo.skuList[0].basePagePoints" type="number" :min="0" :disabled="$route.query.onSale == 'true' ? true : false"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="在线支付价格:" v-if="$route.query.showPoint != 'true'">
          <el-input v-model="skuVo.skuList[0].onlineSalePrice" type="number" :min="0" :disabled="$route.query.onSale == 'true' ? true : false"></el-input>
        </el-form-item>
        <el-form-item label="初创平台价格:" v-if="$route.query.startupsSpu == 'true'">
          <el-input v-model="skuVo.skuList[0].startupsBasePagePrice" type="number" :min="0" :disabled="$route.query.onSale == 'true' ? true : false"></el-input>
        </el-form-item>
        <el-form-item label="最低终端价格:">
          <el-input v-model="skuVo.skuList[0].salePrice" type="number" :min="0" :disabled="$route.query.onSale == 'true' ? true : false"></el-input>
        </el-form-item>
        <el-form-item label="通货编码:" v-if="$route.query.spuProperty === 'NORMAL'">
          <el-input v-model="skuVo.skuList[0].sampleBarCode"></el-input>
        </el-form-item>
        <!-- <el-form-item label="详细价格表:" v-if="$route.query.spuProperty !== 'NORMAL'">
          <el-button round>计算</el-button>
        </el-form-item> -->
        <!-- <el-form-item label="批量数量:">
          <el-input v-model="skuVo.skuList[0].sampleBarCode"></el-input>
        </el-form-item>
        <el-form-item label="批量价格:">
          <el-input v-model="skuVo.skuList[0].sampleBarCode"></el-input>
        </el-form-item> -->
        <el-form-item label="样品价格:" v-if="$route.query.spuProperty !== 'NORMAL'">
          <span style="display:inline-block;width:190px;" v-show="!isEditSamplePrice">{{ skuVo.samplePrice }}</span>
          <el-input v-show="isEditSamplePrice" v-model="skuVo.samplePrice" type="number" :min="0"></el-input>
          <el-button type="primary" @click="isEditSamplePrice = !isEditSamplePrice" round v-if="$route.query.onSale != 'true'">{{ !isEditSamplePrice ? '编辑' : '确定' }}</el-button>
        </el-form-item>
        <el-form-item label="初创平台样品价格:" v-if="$route.query.spuProperty !== 'NORMAL' && $route.query.startupsSpu == 'true'">
          <span style="display:inline-block;width:190px;" v-show="!isEditStartupsSamplePrice">{{ skuVo.startupsSamplePrice }}</span>
          <el-input v-show="isEditStartupsSamplePrice" v-model="skuVo.startupsSamplePrice" type="number" :min="0"></el-input>
          <el-button type="primary" @click="isEditStartupsSamplePrice = !isEditStartupsSamplePrice" round>{{ !isEditStartupsSamplePrice ? '编辑' : '确定' }}</el-button>
        </el-form-item>
        <el-form-item label="在线支付样品价格:" v-if="$route.query.spuProperty !== 'NORMAL'">
          <span style="display:inline-block;width:190px;" v-show="!isEditonlineSamplePrice">{{ skuVo.onlineSamplePrice }}</span>
          <el-input v-show="isEditonlineSamplePrice" v-model="skuVo.onlineSamplePrice" type="number" :min="0"></el-input>
          <el-button type="primary" @click="isEditonlineSamplePrice = !isEditonlineSamplePrice" round v-if="$route.query.onSale != 'true'">{{ !isEditonlineSamplePrice ? '编辑' : '确定' }}</el-button>
        </el-form-item>
        <el-form-item label="样品主题:" v-if="$route.query.spuProperty !== 'NORMAL'">
          <el-select value-key='id' style="margin-bottom:10px" v-model="skuTransferMsg.sampleItem" placeholder="请选择" class="mr-10">
            <el-option :label="item.themeName" :value="item" v-for="item in skuTransferMsg.sampleList" :key="item.id"></el-option>
          </el-select>
          <el-button type="primary" round @click="appendSampleTheme">添加</el-button>
          <el-table :data="skuTransferMsg.sampleTableData" style="width: 602px" border>
            <!-- <el-table-column label="样品编码" min-width="200px" prop="sampleBarCode"></el-table-column> -->
            <el-table-column label="主题" min-width="100px" prop="themeName"></el-table-column>
            <el-table-column label="操作" min-width="100px">
              <template v-slot="scope">
                <span class="color-blue" @click="deleteSampleTheme(scope)">删除</span>
                <span @click="upLoadTheme(scope.row.id, scope.$index)" class="color-blue" style="margin-left: 10px;">上传</span>
                <span @click="(scope.row.isUploaded || scope.row.skuGroupSampleImageList.length > 0) ? previewImg(scope.row.id, scope.$index) : ''"
                  :class="(scope.row.isUploaded || scope.row.skuGroupSampleImageList.length > 0) ? 'color-blue' : ''" style="margin-left: 10px;">预览</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="特殊价格:">
          <div style="width: 500px">
            <el-table :data="specialStoreList" border>
              <el-table-column label="平台号" prop="storeCode"></el-table-column>
              <el-table-column label="平台名称" prop="storeName"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <span @click="$router.push({ path: '/pricedetail', query: { id: scope.row.id, spuProperty: $route.query.spuProperty } })" class="color-blue">查看</span><br>
                  <span @click="deleteSP(scope.row)" class="color-blue">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item label="库存:">
          <el-input v-model="skuVo.stockCount" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="有效期:">
          <el-switch v-model="skuVo.isTimeLimit" active-color="rgba(20, 115, 230, 1)" inactive-color="rgba(140, 140, 140, 1)"> </el-switch>
          <div style="margin-top:10px;" v-show="skuVo.isTimeLimit">
            <el-date-picker v-model="limitTime" type="datetimerange" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button round @click="save" type="primary">确定</el-button>
    </div>
    <!-- 查看尺寸组 -->
    <el-dialog :close-on-click-modal="false" width="800px" title="尺寸组" :visible.sync="sizeGroupDialog">
      <el-table :data="checkSizeGroupTableData" border>
        <el-table-column type="expand">
          <template v-slot='scope'>
            <div style="width:100%;height:100%;background:red">
              <el-table :data="scope.row.sizeList" border>
                <el-table-column label="尺寸名称" prop="sizeName"></el-table-column>
                <el-table-column label="页面类型" prop="typeName"></el-table-column>
                <el-table-column label="页面名称" prop="pageName"></el-table-column>
                <el-table-column label="宽高">
                  <template slot-scope="scope"> {{ scope.row.sizeWidth }}*{{ scope.row.sizeHeight }}mm </template>
                </el-table-column>
                <el-table-column label="出血类型" prop="bleed.bleedName"></el-table-column>
                <el-table-column label="出血" width="220px">
                  <template slot-scope="scope"> 上：{{ scope.row.bleed.bleedTop }}mm 底部：{{ scope.row.bleed.bleedBottom }}mm<br> 内侧：{{ scope.row.bleed.bleedIn }}mm 外侧：{{ scope.row.bleed.bleedOut }}mm
                  </template>
                </el-table-column>
                <el-table-column label="码" prop="barCodeId"></el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="尺寸组名称" min-width="100px" prop="groupName"></el-table-column>
        <el-table-column label="尺寸组类" prop="composeSizeGroupCategory.categoryName" min-width="100px"></el-table-column>
        <el-table-column label="页面名称" prop="pageName" min-width="100px"></el-table-column>
      </el-table>
    </el-dialog>
    <!-- 审核 -->
    <el-dialog :close-on-click-modal="false" title="重要提示" :visible.sync="checkDialog" width="30%">
      <span>是否确认{{ checkStatus === 'AUDIT_SUCCESS' ? '审核通过' : '审核拒绝' }}？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save('not')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加样品主题 -->
    <el-dialog :close-on-click-modal="false" title="请输入样品编码" :visible.sync="addSampleTheme" @closed="sampleBarCode = ''" width="30%">
      <el-input v-model="sampleBarCode" placeholder=""></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="appendSampleTheme">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 上传样品文件 -->
    <el-dialog :close-on-click-modal="false" title="上传文件" :visible.sync="upLoadSampleTheme" @closed="closeSampleTheme" width="500px" v-if="upLoadSampleTheme">
      <el-form :inline="true" class="demo-form-inline" v-for="(item, index) in tagsList" :key="index">
        <el-form-item label="套系内sku:" style="width:100%">
          <span>{{ item.skuName }}<span v-show="item.basePage != item.maxPage">({{ item.basePage }}-{{ item.maxPage }}P)</span><span v-show="item.basePage == item.maxPage">({{ item.basePage
          }}P)</span></span>
        </el-form-item>
        <el-form-item label="上传样片文件:" style="width:100%">
          <!-- <el-upload ref="handleUpload" action="#" :http-request="unloadAccessory" :before-upload="handleBeforeUpload" :show-file-list="false" multiple>
            <el-button size="small" type="primary" @click="handleAddFolder">点击上传</el-button>
          </el-upload> -->
          <el-button size="small" type="primary" @click="handleAddFolder(index, item)">点击上传</el-button>
          <div class="el-upload__tip" v-if="!item.fileName">只能上传文件夹</div>
          <div class="el-upload__tip" v-else>已上传:{{ item.fileName }}</div>
        </el-form-item>
      </el-form>
      <input type="file" webkitdirectory @change="handleFiles" style="display: none" ref="fileInput" />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addThemeFile" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
    <!-- 轮播（预览） -->
    <el-dialog :visible.sync="imgViewerVisible" width="60%" class="dialog" v-if="imgViewerVisible" :fullscreen="isFull" :showClose="false">
      <template slot="title">
        <div style="display:flex; justify-content:space-between;">
          <div>{{ itemImgs.name }}</div>
          <div style="display:flex;">
            <img src="../../../assets/images/page-big.png" width="18px" alt="" @click="isFull = true" v-if="!isFull" />
            <img src="../../../assets/images/page-small.png" width="18px" alt="" @click="isFull = false" v-else />
            <img src="../../../assets/images/close.png" width="18px" alt="" style="margin-left:20px;" @click="imgViewerVisible = false" />
          </div>
        </div>
      </template>
      <div style="text-align: center;width: 100%;">{{ itemImgs.index }}/{{ imageList.length }}</div>
      <div class="dialog-box">
        <div class="switch-btn" @click="onClickCarousel('prev')"><img src="../../../assets/images/carousel-left.png" width="30px" /></div>
        <el-carousel :interval="5000" arrow="never" class="switch-box" :indicator-position="'none'" ref="el-carousel" :loop="false" :autoplay="false" height="400px" @change="carouselChange">
          <!-- <el-carousel-item class="switch" v-if="!isOneLoad"><img :src="UserLookList[0].thumbnailUrl + '?x-sds-process=image/resize,l_160,m_mfit'" @load="changeLoad" />
              </el-carousel-item> -->
          <el-carousel-item v-for="(item, index) in imageList" :key="index" class="switch"><img :src="item.imageUrl" />
          </el-carousel-item>
        </el-carousel>
        <div class="switch-btn" @click="onClickCarousel('next')"><img src="../../../assets/images/carousel-right.png" width="30px" /></div>
      </div>
      <!-- <div class="dialog-btn"><p class="submit" @click="onSubmit" v-if="detailOrder.totalOprt === detailOrder.totalCustomer">确认</p> </div> -->
    </el-dialog>
  </div>
</template>
<script>
import uploadWebImg, { getAwsSdk } from '@/utils/uploadWebImg'
import { sampleListNoPaging, categoryList, queryAllSubs, skuSpecialStoreList, openCategoryList, categoryQuerySub, skuGroupUpdateSeries, skuSpecialPriceDeleteBySpecialId, updateSeriesCurrency, skuSampleDelete, skuSampleSave, composeGroupDetail, skuGroupAudit, spuList, skuGroupDetail, skuGroupSeriesAdd, skuGroupListBySpuId, skuList, saveSampleImage, previewSampleImage } from '@/api/pms'
import { findCloseNum } from '@/utils/transitionFile.js'
import ExifReader from 'exifreader'
import SortLikeWin from '@/utils/sortFile.js'
export default {
  name: 'createSystemSKU',
  data () {
    var _this = this
    return {
      loading: null,
      isFull: false,
      itemImgs: {
        name: '',
        index: 0
      },
      upLoadSampleTheme: false,
      imgViewerVisible: false, // 预览show
      imageList: [],
      addSampleLock: false,
      sampleBarCode: '',
      addSampleTheme: false,
      categoryId: null,
      props: {
        checkStrictly: true,
        emitPath: false,
        lazy: true,
        lazyLoad (node, resolve) {
          const { level, value } = node
          if (level === 0) {
            categoryList(value).then(res => {
              let nodes = res.data.data.map(item => {
                return {
                  value: item.id,
                  label: item.categoryName,
                  leaf: item.bottom || item.id === 4
                }
              })
              nodes = nodes.filter(item => {
                return item.value === +_this.$route.query.categoryId || item.label === '通用'
              })
              resolve(nodes)
            })
          } else if (level === 1) {
            queryAllSubs(value).then(res => {
              let nodes = res.data.data.subCategoryList.map(item => {
                return {
                  value: item.id,
                  label: item.categoryName,
                  leaf: item.subCategoryList.length === 0,
                  subCategoryList: item.subCategoryList
                }
              })
              resolve(nodes)
            })
          } else {
            let nodes = node.data.subCategoryList.map(item => {
              return {
                value: item.id,
                label: item.categoryName,
                leaf: item.subCategoryList.length === 0,
                subCategoryList: item.subCategoryList
              }
            })
            resolve(nodes)
          }
        }
      },
      limitTime: '',
      specialStoreList: [],
      isEditSamplePrice: false,
      isEditonlineSamplePrice: false,
      isEditStartupsSamplePrice: false,
      checkStatus: '',
      checkDialog: false,
      selectSpuId: '',
      sizeGroupDialog: false,
      checkSizeGroupTableData: [],
      skuVo: {
        skuList: [{}],
        samplePrice: '',
        onlineSamplePrice: '',
        startupsSamplePrice: '', // 初创平台价格
        sampleThemeIdSet: [],
        skuGroupImage: '',
        skuGroupName: '',
        stockCount: '',
        spuId: +this.$route.query.spuId
      },
      skuTransferMsg: {
        sampleItem: '',
        sampleList: [],
        sampleTableData: []
      },
      treeData: '',
      treeDataValue: '',
      skuList: {
        skuName: '',
        imgSrc: '',
        proType: '',
        product: '',
        skuGroup: '',
        skuSystem: [],
        price: '',
        samplePrice: '',
        onlineSamplePrice: '',
        startupsSamplePrice: '', // 初创平台价格
        theme: '',
        type: '',
        sampleTheme: '',
        addSampleTheme: []
      },
      options: [],
      tableData: [],
      tags: [],
      tagsList: [],
      spuQueryInfo: {
        pageNum: 1,
        pageSize: 999
      },
      spuList: [],
      skuGroupListBySpuId: []
    }
  },
  created () {
    if (this.$checkAwsSdk('product')) this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    this.getSampleList()
    // this.getSpuList()
    this.getSkuGroupMsg()
  },
  methods: {
    deleteSP (row) {
      skuSpecialPriceDeleteBySpecialId(row.id).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.getSkuGroupMsg()
        }
      })
    },
    // 保存修改
    save (type) {
      if (this.tags.length === 0) {
        this.$message.error('请选择套系内SKU')
        return
      }
      if (this.$route.query.spuProperty === 'NORMAL') {
        let addSeriesCurrencySkuGroupVO = {
          price: this.skuVo.skuList[0].basePagePrice,
          salePrice: this.skuVo.skuList[0].salePrice,
          sampleBarCode: this.skuVo.skuList[0].sampleBarCode,
          onlineSalePrice: this.$route.query.showPoint == 'true' ? this.skuVo.skuList[0].basePagePrice : this.skuVo.skuList[0].onlineSalePrice,
          startupsBasePagePrice: this.skuVo.skuList[0].startupsBasePagePrice,
          startupsSamplePrice: this.skuVo.skuList[0].startupsSamplePrice, // 初创平台价格
          skuGroupImage: this.skuVo.skuGroupImage,
          skuGroupName: this.skuVo.skuGroupName,
          stockCount: this.skuVo.stockCount,
          timeLimitEndTime: this.skuVo.isTimeLimit && this.limitTime ? this.limitTime[1] : '',
          timeLimitStartTime: this.skuVo.isTimeLimit && this.limitTime ? this.limitTime[0] : '',
          skuIds: [],
          skuName: this.skuVo.skuList[0].skuName,
          spuId: this.$route.query.spuId,
          isTimeLimit: this.skuVo.isTimeLimit,
          terminalSalePrice: this.skuVo.skuList[0].salePrice,
          terminalStepSalePrice: 0
        }
        if (this.skuVo.skuList[0].basePagePoints) {
          addSeriesCurrencySkuGroupVO.basePagePoints = this.skuVo.skuList[0].basePagePoints
        }
        this.tags.forEach(item => {
          addSeriesCurrencySkuGroupVO.skuIds.push(item.id)
        })

        updateSeriesCurrency({ skuGroupId: this.$route.query.id, addSeriesCurrencySkuGroupVO }).then(res => {
          if (res.data.success) {
            if (type !== 'not') {
              this.$message.success('更新成功')
              this.$router.go(-1)
            } else {
              this.check(this.checkStatus)
            }
          }
        })
      } else {
        let skuVo = {
          onlineSamplePrice: this.skuVo.onlineSamplePrice,
          startupsSamplePrice: this.skuVo.startupsSamplePrice,
          samplePrice: this.skuVo.samplePrice,
          simpleSkuSeriesVo: {
            basePagePrice: this.skuVo.skuList[0].basePagePrice,
            basePagePoints: this.skuVo.skuList[0].basePagePoints,
            salePrice: this.skuVo.skuList[0].salePrice,
            onlineSalePrice: this.$route.query.showPoint == 'true' ? this.skuVo.skuList[0].basePagePrice : this.skuVo.skuList[0].onlineSalePrice,
            startupsBasePagePrice: this.skuVo.skuList[0].startupsBasePagePrice,
            skuIdSet: [],
            terminalSalePrice: this.skuVo.skuList[0].salePrice,
            terminalStepSalePrice: 0
          },
          skuGroupImage: this.skuVo.skuGroupImage,
          skuGroupName: this.skuVo.skuGroupName,
          stockCount: this.skuVo.stockCount,
          timeLimitEndTime: this.skuVo.isTimeLimit && this.limitTime ? this.limitTime[1] : '',
          timeLimitStartTime: this.skuVo.isTimeLimit && this.limitTime ? this.limitTime[0] : '',
          isTimeLimit: this.skuVo.isTimeLimit
        }
        this.tags.forEach(item => {
          skuVo.simpleSkuSeriesVo.skuIdSet.push(item.id)
        })
        skuGroupUpdateSeries({ skuGroupId: this.$route.query.id, skuId: this.skuVo.skuList[0].id, skuVo }).then(res => {
          if (res.data.success) {
            if (type !== 'not') {
              this.$message.success('更新成功')
              this.$router.go(-1)
            } else {
              this.check(this.checkStatus)
            }
          }
        })
      }
    },
    // 修改样品价格
    editSamplePrice () {
      this.isEditSamplePrice = !this.isEditSamplePrice
    },
    // 修改样品价格
    editonlineSamplePrice () {
      this.isEditonlineSamplePrice = !this.isEditonlineSamplePrice
    },
    // 审核
    check (status) {
      skuGroupAudit({ skuGroupId: this.$route.query.id, status }).then(res => {
        if (res.data.success) {
          this.$message.success(status === 'AUDIT_SUCCESS' ? '审核通过' : '审核拒绝')
          this.checkDialog = false
          this.$router.go(-1)
        }
      })
    },
    // 获取sku组详情
    getSkuGroupMsg () {
      skuGroupDetail(this.$route.query.id).then(res => {
        if (res.data.success) {
          this.skuVo = res.data.data
          this.tags = res.data.data.skuList[0].seriesAssociateSkuList
          this.tagsList = res.data.data.skuList[0].seriesAssociateSkuList
          console.log('this.tagsList', this.tagsList)
          this.skuTransferMsg.sampleTableData = res.data.data.sampleThemeList
        }
      })
      // 获取特殊价格加盟店列表
      skuSpecialStoreList(this.$route.query.id).then(res => {
        if (res.data.success) {
          this.specialStoreList = res.data.data.data
        }
      })
    },
    // -------------------------------------------------------------------
    // 创建新SKU组
    createSku () {
      skuGroupSeriesAdd(this.skuVo).then(res => {
        if (res.data.success) {
          this.$message.success('创建成功')
          this.$router.push('/productlist')
        }
      })
    },
    // 获得sku组下sku列表
    getSkuListBySkuGroupId () {
      skuList(this.skuList.skuGroup.id).then(res => {
        this.tableData = res.data.data.filter(item => {
          return !item.themeId
        })
      })
    },
    // 获取产品的SKU组详细信息
    getSpuMsg () {
      skuGroupListBySpuId({ pageNum: 1, pageSize: 1000, spuId: this.selectSpuId }).then(res => {
        if (res.data.success) {
          this.skuGroupListBySpuId = res.data.data.records.filter(item => {
            return item.onSale
          })
        }
      })
    },
    // 获取产品列表
    getSpuList (val) {
      if (val === null) {
        this.selectSpuId = ''
      }
      spuList({ pageNum: this.spuQueryInfo.pageNum, pageSize: this.spuQueryInfo.pageSize, spuVO: { categoryId: val, isSeries: 0, onSale: 1, spuProperty: this.$route.query.spuProperty } }).then(res => {
        if (res.data.success) {
          this.spuList = res.data.data.records
        }
      })
    },
    // 查看尺寸组
    checkSizeGroup (row) {
      composeGroupDetail(row.composeSizeGroupId).then(res => {
        if (res.data.success) {
          this.checkSizeGroupTableData = [res.data.data]
        }
      })
      this.sizeGroupDialog = true
    },
    // 删除主题
    deleteSampleTheme (scope) {
      skuSampleDelete({ skuGroupId: this.$route.query.id, themeId: scope.row.id }).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.skuTransferMsg.sampleTableData.splice(scope.$index, 1)
        }
      })
    },
    // sampleThemeAdd () {
    //   if (this.skuTransferMsg.sampleItem === '') {
    //     this.$message.error('请选择样品主题')
    //     return
    //   }
    //   this.addSampleTheme = true
    // },
    // 添加主题
    async appendSampleTheme () {
      if (this.skuTransferMsg.sampleItem === '') {
        this.$message.error('请选择样品主题')
        return
      }
      // 判断是否已经添加
      let lock = false
      this.skuTransferMsg.sampleTableData.forEach(item => {
        if (item.id === this.skuTransferMsg.sampleItem.id) {
          lock = true
        }
      })
      if (lock) {
        this.$message.error('已存在该主题')
        return
      }
      this.addSampleLock = true
      // sampleBarCode: this.sampleBarCode ? this.sampleBarCode : 'NO_CODE' // c传样品编码的时候
      await skuSampleSave({ skuGroupId: this.$route.query.id, themeId: this.skuTransferMsg.sampleItem.id }).then(res => {
        if (res.data.success) {
          this.skuTransferMsg.sampleTableData.push({ sampleBarCode: this.sampleBarCode, ...this.skuTransferMsg.sampleItem, skuGroupSampleImageList: [] })
          this.$message.success('添加成功')
          this.addSampleTheme = false
        }
      })
      this.addSampleLock = false
    },
    // 获取样品主题列表
    getSampleList () {
      sampleListNoPaging().then(res => {
        if (res.data.success) {
          this.skuTransferMsg.sampleList = res.data.data
        }
      })
    },
    // 上传样品文件
    upLoadTheme (id) {
      this.sampleThemeId = id
      this.upLoadSampleTheme = true
    },
    // 点击上传按钮
    async handleAddFolder (index, item) {
      // this.$nextTick(() => {
      //   // this.uploadImgsList = []
      //   this.$refs.handleUpload.$children[0].$refs.input.webkitdirectory = true
      // })
      console.log('item', item)
      let res = await composeGroupDetail(item.composeSizeGroupId)
      if (res.data.success) {
        this.defaultSizeGroup = res.data.data
      }
      this.coverPageNum = item.coverPage ? item.coverPage : 0
      this.maxPage = item.maxPage + this.coverPageNum
      this.minPage = item.basePage + this.coverPageNum
      this.fileInputIndex = index
      this.$refs.fileInput.click()
    },
    // 上传文件夹
    async handleFiles (event) {
      console.log('event', event.target.files)
      const files = []
      let filesList = []
      for (let key in event.target.files) {
        console.log('key', key)
        if (key !== 'length' && key !== 'item') {
          let file = event.target.files[key]
          filesList.push(file)
        }
      }
      filesList.forEach(a => {
        if (a.name.split('.').pop() != 'db') {
          files.push(a)
        }
      }) // 过滤出隐藏文件
      if (files.length === 0) {
        return
      }
      let coverPageList = files.filter(a => a.name.includes('封面'))
      if (coverPageList.length !== this.coverPageNum) {
        this.$message.error('上传图片封面数量与当前sku的封面页数不一致')
        return
      }
      // 验证上传图片数量与实际需要上传数量是否一致
      if (this.maxPage == this.minPage) {
        if (files.length !== this.minPage) {
          this.$message.error('上传图片数量与当前sku的P数不一致')
          return
        }
      } else {
        if (files.length > this.maxPage) {
          this.$message.error('上传图片数量不能大于最大P数')
          return
        }
        if (files.length < this.minPage) {
          this.$message.error('上传图片数量不能小于最小P数')
          return
        }
      }
      files.sort(SortLikeWin)
      // 将封面排在最前面
      // let obj = {}
      // files.forEach((item, index) => {
      //   if (item.name.slice(0, item.name.lastIndexOf('.')) === '封面') {
      //     obj = item
      //     files.splice(index, 1)
      //     return true
      //   }
      // })
      // if (obj.name) {
      //   files.unshift(obj)
      // }
      let coverPage = files.filter(a => a.name.includes('封面'))
      let insidePage = files.filter(a => !a.name.includes('封面'))
      let filesNew = coverPage.concat(insidePage)
      console.log('filesNew', filesNew)
      this.loading = this.$loading({
        lock: true,
        text: '正在上传文件夹，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$set(this.tagsList[this.fileInputIndex], 'fileName', '')
      this.$set(this.tagsList[this.fileInputIndex], 'upLoadImgList', [])
      // 这里可以将文件上传到服务器
      this.imageAssemble(filesNew, 0)
    },
    imageAssemble (files, i) {
      let that = this
      ExifReader.load(files[i]).then(async (tags) => {
        console.log('tagsssss', tags)
        if (!tags.XResolution) {
          that.$message.error('您提交的图片不符合要求，请重新调整后再上传')
          that.loading.close()
          return
        }
        // 新增:为了解决读取出来的格式是3000000/10000
        if (tags.XResolution?.description.includes('/')) {
          tags.XResolution.description = that.convertToPixels(tags.XResolution.description)
          console.log('tags.XResolution.description', tags.XResolution.description)
        }
        if (tags.YResolution?.description.includes('/')) {
          tags.YResolution.description = that.convertToPixels(tags.YResolution.description)
          console.log('tags.YResolution.description', tags.YResolution.description)
        }
        let rotateValue = tags.Orientation?.value
        let img = {
          width: tags['Image Width'].value,
          height: tags['Image Height'].value,
          xdpi: tags.XResolution?.description || 96,
          ydpi: tags.YResolution?.description || 96,
          // ColorSpace: tags['Color Space'] ? tags['Color Space'] : tags.ColorSpace
          color: tags['Color Components']?.description,
          rotate: rotateValue ? (rotateValue == 8 ? 270 : rotateValue == 6 ? 90 : rotateValue == 1 ? 0 : rotateValue == 3 ? 180 : 0) : 0
        }
        // var pageTypeCodeName = files[i].name.includes('封面') ? 'COVER' : files.length == 1 ? 'SINGLE' : 'TEXT'
        var pageTypeCodeName = 'TEXT'
        if (that.tagsList[that.fileInputIndex].skuPageSettingList.length == 1) {
          pageTypeCodeName = that.tagsList[that.fileInputIndex].skuPageSettingList[0].skuPageType
        } else if (that.tagsList[that.fileInputIndex].skuPageSettingList.length == 2) {
          pageTypeCodeName = files[i].name.includes('封面') ? 'COVER' : 'TEXT'
        }
        console.log('pageTypeCodeName', pageTypeCodeName, img.rotate)
        let spuDpi = findCloseNum([254, 300], +img.xdpi)
        let item = that.checkPageSize(
          i,
          files,
          (img.width / spuDpi) * 25.4,
          (img.height / spuDpi) * 25.4,
          img.xdpi,
          img.ydpi,
          pageTypeCodeName,
          img.color,
          spuDpi,
          img.rotate
        )
        if (item.error) {
          that.loading.close()
          that.$message.error(item.error)
          return
        }
        console.log('上传图片++++++', item)
        await uploadWebImg(files[i], that.$store.state.awsSdk.product.s3).then(res => {
          console.log('resresresres', res)
          that.tagsList[that.fileInputIndex].upLoadImgList.push({
            sorting: i,
            url: res,
            imageName: files[i].name,
            pageTypeCode: pageTypeCodeName,
            imgDetail: JSON.stringify(img),
            rotate: item.type === 2 ? (img.rotate + 90) : img.rotate
          })
          i++
          // console.log('上传成功', that.upLoadImgList)
          if (i == files.length) {
            console.log('上传完成', files[0])
            that.loading.close()
            let fileName = files[0].webkitRelativePath.split('/')[0]
            that.$set(that.tagsList[that.fileInputIndex], 'fileName', fileName)
            console.log('that.tagsList', that.tagsList)
          } else {
            that.imageAssemble(files, i)
          }
          // this.fileName = data.file.name
        })
      })
    },
    // 校验图片
    checkPageSize (index, files, width, height, xdpi, ydpi, pageType, color, spuDpi, rotate) {
      console.log('this.defaultSizeGroup.sizeList', this.defaultSizeGroup.sizeList, pageType)
      // let oneName = files[0].name
      let coverPages = files.filter(a => a.name.includes('封面'))
      let sizeList = this.defaultSizeGroup.sizeList.find(a => a.pageTypeCode == pageType)
      console.log('sizeList', sizeList)
      let sizeHeightError = sizeList.sizeHeight < 100 ? 1 : Math.floor(sizeList.sizeHeight * 0.01)
      let sizeWidthError = sizeList.sizeWidth < 100 ? 1 : Math.floor(sizeList.sizeWidth * 0.01)
      // 宽高增加出血尺寸
      let newWidth = sizeList.sizeWidth + sizeList.bleed.bleedLeft + sizeList.bleed.bleedRight
      if (this.tagsList[this.fileInputIndex].specialLayout && (index == coverPages.length || (index == (files.length - 1)))) {
        // 特殊排版校验宽度(首页是封面的时候，校验第二P,首页不是封面的时候，校验第一P,最后一P,是不是传的一半的尺寸)
        width = width * 2
      }
      // 宽高增加出血尺寸
      let newHeight = sizeList.sizeHeight + sizeList.bleed.bleedTop + sizeList.bleed.bleedBottom
      console.log('宽高-----', width, newWidth)
      console.log('高宽++++', height, newHeight)
      // 宽宽，高高相同    宽高，高宽相同
      let w = Math.abs(width - newWidth)
      if (this.tagsList[this.fileInputIndex].specialLayout && (index == coverPages.length || (index == (files.length - 1)))) {
        // 特殊排版，由于宽度*了2，导致误差值翻倍，所以这里误差值要再/2
        w = w / 2
      }
      let h = Math.abs(height - newHeight)
      let wh = Math.abs(width - newHeight)
      let hw = Math.abs(height - newWidth)
      let w1 = sizeWidthError
      let h1 = sizeHeightError
      let error = ''
      let type = 0
      let sizeError = (pageType === 'COVER' ? '封面' : pageType === 'SINGLE' ? '单页' : '内页') + '尺寸错误'
      if (!(color === '3' || color === 'RGB' || color === 'RGB with Alpha')) {
        error = '色彩模式应为RGB'
      } else if ((spuDpi === 300 && (+xdpi > 301 || +ydpi > 301)) || (spuDpi === 254 && (+xdpi < 253 || +ydpi < 253))) {
        error = '分辨率错误'
      } else if (newWidth == newHeight) {
        // 新加的：宽高尺寸相同的时候，只要一边大于误差值尺寸就不对
        if (w > w1 || h > h1) {
          error = sizeError
        } else {
          error = ''
        }
      } else {
        // 旋转角度是90或者270 旋转之后的宽高匹配 (这里倒过来匹配是因为：旋转之后的宽高，获取到的是之前的)
        if (rotate == 90 || rotate == 270) {
          if (wh > w1 || hw > h1) {
            // 相框，摆台判断颠倒过来之后的宽高误差值，如果也匹配不上，尺寸错误
            if (pageType === 'SINGLE') {
              if (w > w1 || h > h1) {
                error = sizeError
              } else {
                error = ''
                type = 2
              }
            } else {
              error = sizeError
            }
          } else {
            error = ''
          }
        } else {
          // 只要宽高有一边匹配不上
          if (w > w1 || h > h1) {
            // 相框，摆台判断颠倒过来之后的宽高误差值，如果也匹配不上，尺寸错误
            if (pageType === 'SINGLE') {
              // 判断颠倒过来之后的宽高误差值，如果也匹配不上，尺寸错误
              if (wh > w1 || hw > h1) {
                error = sizeError
              } else {
                error = ''
                type = 2
              }
            } else {
              error = sizeError
            }
          } else {
            error = ''
          }
        }
      }
      return {
        error,
        type
      }
    },
    // 确定上传
    async addThemeFile () {
      console.log('this.tagsList', this.tagsList)
      let haveNoFile = this.tagsList.filter(a => !a.upLoadImgList)
      if (haveNoFile.length) {
        this.$message.error('存在未上传文件的sku,请上传')
        return
      }
      let sampleSkuImageVOS = []
      this.tagsList.forEach(res => {
        let pageTypeVOS1 = res.upLoadImgList.filter(a => a.pageTypeCode == 'COVER') // 封面
        let pageTypeVOS2 = res.upLoadImgList.filter(a => {
          if (a.pageTypeCode == 'TEXT' || a.pageTypeCode == 'SINGLE') {
            return a
          }
        })
        let pageTypeVOS = []
        if (pageTypeVOS1.length > 0) {
          pageTypeVOS = [{
            imageUrlVOS: pageTypeVOS1.map(a => {
              return {
                sorting: a.sorting,
                url: a.url,
                imgDetail: a.imgDetail,
                name: a.imageName,
                rotate: a.rotate
              }
            }),
            pageTypeCode: pageTypeVOS1[0].pageTypeCode
          }, {
            imageUrlVOS: pageTypeVOS2.map((a, i) => {
              // return {
              //   sorting: a.sorting,
              //   url: a.url,
              //   name: a.imageName
              // }
              if (res.specialLayout && i == 0) {
                return {
                  sorting: a.sorting,
                  url: a.url,
                  name: a.imageName,
                  imgDetail: a.imgDetail,
                  rotate: a.rotate,
                  specialLayout: true,
                  specialLayoutWhitePagePosition: 'LEFT'
                }
              } else if (res.specialLayout && i == (pageTypeVOS2.length - 1)) {
                return {
                  sorting: a.sorting,
                  url: a.url,
                  name: a.imageName,
                  rotate: a.rotate,
                  imgDetail: a.imgDetail,
                  specialLayout: true,
                  specialLayoutWhitePagePosition: 'RIGHT'
                }
              } else {
                return {
                  sorting: a.sorting,
                  url: a.url,
                  imgDetail: a.imgDetail,
                  name: a.imageName,
                  rotate: a.rotate
                }
              }
            }),
            pageTypeCode: pageTypeVOS2[0].pageTypeCode
          }]
        } else {
          pageTypeVOS = [{
            imageUrlVOS: pageTypeVOS2.map((a, i) => {
              // return {
              //   sorting: a.sorting,
              //   url: a.url,
              //   name: a.imageName
              // }
              if (res.specialLayout && i == 0) {
                return {
                  sorting: a.sorting,
                  url: a.url,
                  imgDetail: a.imgDetail,
                  name: a.imageName,
                  specialLayout: true,
                  rotate: a.rotate,
                  specialLayoutWhitePagePosition: 'LEFT'
                }
              } else if (res.specialLayout && i == (pageTypeVOS2.length - 1)) {
                return {
                  sorting: a.sorting,
                  url: a.url,
                  imgDetail: a.imgDetail,
                  name: a.imageName,
                  specialLayout: true,
                  rotate: a.rotate,
                  specialLayoutWhitePagePosition: 'RIGHT'
                }
              } else {
                return {
                  sorting: a.sorting,
                  url: a.url,
                  imgDetail: a.imgDetail,
                  rotate: a.rotate,
                  name: a.imageName
                }
              }
            }),
            pageTypeCode: pageTypeVOS2[0].pageTypeCode
          }]
        }
        sampleSkuImageVOS.push({
          pageTypeVOS: pageTypeVOS,
          skuId: res.id
        })
      })
      let params = {
        sampleSkuImageVOS: sampleSkuImageVOS,
        skuGroupId: this.$route.query.id,
        themeId: this.sampleThemeId
      }
      let res = await saveSampleImage(params)
      console.log('res', res)
      if (res.data.success) {
        this.$message.success('上传成功')
        this.closeSampleTheme()
        this.skuTransferMsg.sampleTableData = this.skuTransferMsg.sampleTableData.map(a => {
          if (a.id == this.sampleThemeId) {
            return {
              ...a,
              isUploaded: true
            }
          } else {
            return a
          }
        })
        console.log('this.skuTransferMsg.sampleTableData', this.skuTransferMsg.sampleTableData)
      }
    },
    closeSampleTheme () {
      this.upLoadSampleTheme = false
      this.sampleThemeForm = {}
      this.upLoadImgList = []
    },
    // 预览样品图片
    async previewImg (id) {
      let val = {
        skuGroupId: this.$route.query.id,
        id: id
      }
      let res = await previewSampleImage(val)
      console.log('res', res)
      if (res.data.success) {
        this.imageList = []
        res.data.data.forEach(a => {
          a.pageTypeVOS.forEach(b => {
            // console.log('b.imageInfos', b.imageInfos)
            this.imageList = this.imageList.concat(b.imageInfos)
          })
        })
        // res.data.data[0].pageTypeVOS[0].imageInfos
        this.itemImgs.name = this.imageList[0].imageName
        this.itemImgs.index = 1
        this.imgViewerVisible = true
      }
    },
    // 轮播图切换
    carouselChange (i) {
      console.log('val', i)
      this.itemImgs.name = this.imageList[i].imageName
      this.itemImgs.index = i + 1
    },
    /* 预览轮播切换 */
    onClickCarousel (type) {
      if (type === 'prev') this.$refs['el-carousel'].prev()
      if (type === 'next') this.$refs['el-carousel'].next()
    },
    // 上传图片
    upload (el) {
      let file = el.target.files[0]
      if (['image/png', 'image/jpg', 'image/jpeg', 'image/svg', 'image/svg+xml', 'image/webp'].indexOf(file.type) === -1) {
        this.$message.warning('请上传正确的图片格式')
        return false
      }
      uploadWebImg(file, this.$store.state.awsSdk.product.s3).then(res => {
        this.skuVo.skuGroupImage = res
      })
    },
    // --------------------------------------------------------------
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    handleClose (val, index) {
      this.tags.splice(index, 1)
    },
    RowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    addSKUGroup (val) {
      let lock = false
      this.tags.forEach(item => {
        if (item.id === val.id) {
          lock = true
        }
      })
      if (lock) {
        this.$message.error('已经添加该sku')
        return
      }
      this.tags.push(val)
    },
    returnPage () {
      if (window.history.length <= 1) {
        this.$router.push({ path: '/home' })
        return false
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>
<style scoped lang="less">
@import "styles";

@deep: ~">>>";

.dialog {
  // position: relative;
  display: flex;
  flex-direction: column;
  //  background-color: #aaa !important;

  .btn-close {
    position: absolute;
    width: 90%;
    margin: -20px auto 0;
    display: flex;
    justify-content: flex-end;

    img {
      width: 34px;
      height: 34px;
      cursor: pointer;
    }
  }

  .dialog-box {
    // width: 100%;
    display: flex;
  }

  .switch-btn {
    margin-top: 180px;
    width: 40px;
    height: 40px;
  }

  .switch-box {
    width: 80%;
    margin: 0 auto;

    .switch {
      // width: 80%;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        // width: 868px;
        max-width: 100%;
        max-height: 100%;
      }
    }
  }

  .dialog-title {
    // background: #e4e4e5;
    height: 57px;
    // width: 102.7%;
    line-height: 57px;
    margin-top: -30px;
    padding-left: 2.66%;
    margin-left: -2.66%;
    margin-bottom: 20px;
    font-size: 16px;
  }

  .dialog-btn {
    width: 100%;
    display: flex;
    justify-content: flex-end;

    .submit {
      width: 100px;
      height: 40px;
      cursor: pointer;
      margin-top: 30px;
      background-color: #000;
      border-radius: 50px;
      line-height: 40px;
      text-align: center;
      color: white;
      font-size: 16px;
    }
  }
}

.switch-box {
  width: 80%;
  margin: 0 auto;

  .switch {
    // width: 80%;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      // width: 868px;
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>
